import { createContext, useState } from "react";

const RouteGuardContext = createContext();

const RouteGuardContextProvider = ({ children }) => {
  const [isNavigationAllowed, setIsNavigationAllowed] = useState(false);
  // const isFormDirty = useRef(false);


  const setFormState = (isNavigationAllowed) => {
    setIsNavigationAllowed(isNavigationAllowed);
    // isFormDirty.current = isDirty;
  };

  const getFormState = () => {
    return isNavigationAllowed;
    // return isFormDirty.current;
  };

  return <RouteGuardContext.Provider value={{ getFormState, setFormState }}>{children}</RouteGuardContext.Provider>;
};

export { RouteGuardContext, RouteGuardContextProvider };
